import { useEffect, useRef } from "react";
import confetti from "canvas-confetti";

const ConfettiBackground = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (!canvasRef.current) return;

    const myConfetti = confetti.create(canvasRef.current, {
      resize: true,
      useWorker: true,
    });

    const interval = setInterval(() => {
      myConfetti({
        particleCount: 20,
        spread: 80,
        origin: { y: 0 },
      });
    }, 300);

    return () => clearInterval(interval);
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: "absolute",
        inset: 0,
        pointerEvents: "none",
        zIndex: 3,
        width: "100%",
      }}
    />
  );
};

export default ConfettiBackground;
